import { render, staticRenderFns } from "./SuppEdit.vue?vue&type=template&id=0146fe40&scoped=true&"
import script from "./SuppEdit.vue?vue&type=script&lang=js&"
export * from "./SuppEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146fe40",
  null
  
)

export default component.exports